// CaptureStory.jsx
// Headless-capture target for the animated Story mp4. Renders StoryAnimator
// (no preview chrome, no safe-area guides) for a shift, reading the PII-safe
// publicShiftRecaps doc — so it works unauthenticated (the render function's
// headless Chrome isn't logged in). Sets window.__storyReady once fonts +
// first frame are settled so the recorder knows when to start.
//
// Route: /social/capture?shift=<shiftId>&w=<px>  (public)
// `w` (default 1080) lets the recorder capture at reduced resolution — the
// 1080x1920 stage CSS-scales down inside StoryAnimator, and ffmpeg upscales
// the frames back to 1080x1920. Half-res capture is ~4x fewer pixels per
// screenshot, which is what keeps the render inside the function timeout.

import { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import StoryAnimator from "./StoryAnimator";
import { computeOverlay } from "./storyOverlay";

export default function CaptureStory() {
  const [recap, setRecap] = useState(null);
  const params = new URLSearchParams(window.location.search);
  const shiftId = params.get("shift");
  const w = Math.max(270, Math.min(1080, parseInt(params.get("w"), 10) || 1080));

  useEffect(() => {
    if (!shiftId) return;
    getDoc(doc(db, "publicShiftRecaps", shiftId)).then((s) => { if (s.exists()) setRecap(s.data()); }).catch(() => {});
  }, [shiftId]);

  useEffect(() => {
    if (!recap) return;
    let t;
    const arm = () => { t = setTimeout(() => { window.__storyReady = true; }, 900); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(arm); else arm();
    return () => clearTimeout(t);
  }, [recap]);

  const pancakes = recap ? (recap.pancakes || []).filter((p) => p.cutoutUrl || p.thumbUrl) : [];

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: w, height: Math.round(w * 1920 / 1080), overflow: "hidden", background: "#081a2a" }}>
      {recap && <StoryAnimator width={w} renderScale={w / 1080} showGuides={false} pancakes={pancakes} overlay={computeOverlay(recap)} />}
    </div>
  );
}
